// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2Xs4_","icon":"SortAdornment_icon__2hRha","up":"SortAdornment_up__5xY2V","down":"SortAdornment_down__2OzH7","active":"SortAdornment_active__F3QNn"};